// import axios from 'axios';

// const isLocalhost = Boolean(
//     window.location.hostname === 'localhost' ||
    
//     window.location.hostname === '[::1]' ||
   
//     window.location.hostname.match(
//         /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
//     )
// );

// const axiosClient = axios.create({
//     baseURL: isLocalhost
//         ? 'http://192.168.1.5:5000/api'
//         : 'https://tgpl.onsapp.com/api'
// });



// // const axiosClient = axios.create({
// //     baseURL: isLocalhost
// //         ? 'http://198.38.85.240:2311/api'
// //         : 'http://198.38.85.240:2311/api',
// // });



// // const axiosClient = axios.create({
// //          baseURL: isLocalhost
// //         ? 'https://tgpl.onsapp.com/api'
// //         : 'https://tgpl.onsapp.com/api',
// // });


    
// export default axiosClient;


import axios from 'axios';

const isLocalhost = Boolean(
    window.location.hostname === 'localhost' ||

    window.location.hostname === '[::1]' ||

    window.location.hostname.match(
        /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    ) ||

    // ✅ LAN IPs (192.168.x.x, 10.x.x.x) ko bhi local treat karo,
    //    taaki dusre device se LAN pe test karte waqt local backend hi hit ho, production nahi
    window.location.hostname.match(
        /^192\.168\.\d{1,3}\.\d{1,3}$/
    ) ||
    window.location.hostname.match(
        /^10\.\d{1,3}\.\d{1,3}\.\d{1,3}$/
    )
);

const axiosClient = axios.create({
    baseURL: isLocalhost
        ? 'http://192.168.1.8:5000/api'
        : 'https://tgpl.onsapp.com/api'
});

export default axiosClient;
